import React, { useEffect, useRef, useState } from "react";
import {
  incCount,
  decCount,
  getTravellers,
  setSignature,
  fetchAirHotelData,
  getListData,
  getSearchedTransfers,
  transferSearchAsync,
  setTravellersCount,
  transferSearchReturnAsync,
} from "../../features/bookings/transferSlice";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import Counter from "../UI/Counter";
import DatePicker from "react-datepicker";
import { TimePicker } from "antd";
import "antd/dist/antd.min.css";
import "rc-time-picker/assets/index.css";
import SearchButton from "../UI/SearchButton";
import moment from "moment/moment";
import { slashFormatter } from "../../helpers/helper";
import {
  createSearchParams,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { errorToast } from "../../helpers/toaster";

const TransferForm = () => {
  const [tripType, setTripType] = useState("oneway");
  const [locationType, setLocationType] = useState(0);
  const [currentInput, setCurrentInput] = useState("");

  const [pickUpInput, setPickUpInput] = useState("");
  const [pickUpType, setPickUpType] = useState("Airport");
  const [pickUpList, setPickUpList] = useState([]);
  const [pickupCity, setPickupCity] = useState("");
  const [pickupHover, setPickupHover] = useState(false);

  const [dropInput, setDropInput] = useState("");
  const [dropType, setDropType] = useState("Hotel");
  const [dropList, setDropList] = useState([]);
  const [dropoffCity, setDropoffCity] = useState("");
  const [dropoffHover, setDropoffHover] = useState(false);

  const [depature, setDepature] = useState({});
  const [returnJourney, setReturnJourney] = useState({});

  const [startPickup, setStartPickup] = useState(
    new Date().setDate(new Date().getDate() + 1),
  );
  const endDateAll = new Date().setFullYear(new Date().getFullYear() + 1);

  const [pickUpDate, setPickUpDate] = useState("");
  const [pickupTime, setPickUpTime] = useState("");

  const [returnDate, setReturnDate] = useState("");

  const [returnTime, setReturnTime] = useState("");
  const [minReturn, setMinReturn] = useState("");

  const [isSubmit, setIsSubmit] = useState(false);
  const [formErrors, setFormErrors] = useState({});

  const [returnInput, setReturnInput] = useState("");

  const pickupRef = useRef();
  const dropRef = useRef();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [queryData, setQueryData] = useState(
    Object.fromEntries([...searchParams]),
  );
  const { Authorization } =
    JSON.parse(sessionStorage.getItem("userData")) || {};
  const [returnPopup, setReturnPopup] = useState(false);

  const dispatch = useDispatch();
  const travellersCount = useSelector(getTravellers);

  const listData = useSelector(getListData);
  const searchedTransfers = useSelector(getSearchedTransfers);
  const signatureData = useSelector(
    (state) => state.transfer.signature,
    shallowEqual,
  );

  useEffect(() => {
    dispatch(setSignature());
  }, []);

  useEffect(() => {
    if (listData.length > 0) {
      if (pickUpType === currentInput) {
        setPickUpList(listData);
      } else {
        setDropList(listData);
      }
    }
  }, [listData]);

  const setDepartureWith = (val) => {
    setDepature(val);

    val.PickUp.LocationType === "TransferAccomodationDetail"
      ? setLocationType(1)
      : setLocationType(0);

    setPickUpInput(val.PickUp.locationName);
    setDropInput(val.DropOff.locationName);

    let dt = val.TransferDate.split("T")[0];
    setPickUpDate(
      new Date(dt).getTime() - new Date(dt).getTimezoneOffset() * 60000,
    );

    let tm = moment(val.TransferDate).add(1, "days")._d;
    setMinReturn(tm.getTime() - tm.getTimezoneOffset() * 60000);

    dispatch(setTravellersCount(val?.tcount));

    setPickUpTime(moment(val.TransferTime, "HH:mm"));
  };

  const setReturnWith = (val) => {
    setTripType("roundtrip");
    let now = new Date(val.TransferDate);

    setReturnDate(now.getTime() - now.getTimezoneOffset() * 60000);
    setReturnInput(
      slashFormatter(val?.TransferDate).concat(` ${val?.TransferTime}`),
    );
    setReturnTime(moment(val.TransferTime, "HH:mm"));

    setReturnJourney(val);
  };

  useEffect(() => {
    if (Object.keys(queryData).length > 0) {
      let depature = JSON.parse(queryData?.departure);
      setDepartureWith(depature);

      let returnJourney;
      if (queryData.hasOwnProperty("returnJourney")) {
        returnJourney = JSON.parse(queryData?.returnJourney);

        setReturnWith(returnJourney);
        if (JSON.parse(sessionStorage.getItem("depature")) === null) {
          sessionStorage.setItem("return", JSON.stringify(returnJourney));
        }
        sessionStorage.setItem("roundTrip", true);
      }

      if (JSON.parse(sessionStorage.getItem("depature")) === null) {
        sessionStorage.setItem("departure", JSON.stringify(depature));
      }
    } else {
      let depature = JSON.parse(sessionStorage.getItem("departure"));
      let roundTrip = JSON.parse(sessionStorage.getItem("roundTrip"));

      if (roundTrip !== null) {
        roundTrip ? setTripType("roundtrip") : setTripType("oneway");
      }
      if (depature !== null) {
        setDepartureWith(depature);

        let returnJourney = JSON.parse(sessionStorage.getItem("return"));
        if (returnJourney !== null) {
          setReturnWith(returnJourney);
        }
      }
    }
  }, [queryData]);

  useEffect(() => {
    if (Object.keys(formErrors).length === 0 && isSubmit) {
      depature.tcount = travellersCount;
      sessionStorage.setItem("departure", JSON.stringify(depature));

      if (tripType === "roundtrip") {
        sessionStorage.setItem("roundTrip", true);
        sessionStorage.setItem("return", JSON.stringify(returnJourney));
        dispatch(
          transferSearchReturnAsync({ depature, returnJourney, signatureData }),
        );
      } else {
        sessionStorage.setItem("roundTrip", false);
      }
      depature.tcount = travellersCount;
      let obj;
      if (tripType === "roundtrip") {
        obj = {
          departure: JSON.stringify(depature),
          returnJourney: JSON.stringify(returnJourney),
          tripType: tripType,
        };
      } else {
        obj = { departure: JSON.stringify(depature), tripType: tripType };
      }

      {
        obj !== undefined &&
          navigate({
            pathname: "/transfer-listing",
            search: `${createSearchParams(obj)}`,
          });
      }
      sessionStorage.setItem("transferSelected", "");
    }
  }, [formErrors]);

  useEffect(() => {
    if (locationType === 0) {
      setPickUpType("Airport");
      setDropType("Hotel");
    } else {
      setPickUpType("Hotel");
      setDropType("Airport");
    }
  }, [locationType]);

  const handleCheckBox = (e) => {
    setTripType(e.target.value);
  };

  const handleReturnTransfer = (state) => {
    if (state === "open") {
      setReturnPopup(true);
    } else {
      setReturnPopup(false);

      returnJourney.TransferDate !== undefined &&
        returnJourney.TransferTime !== undefined &&
        setReturnInput(
          slashFormatter(returnJourney?.TransferDate).concat(
            ` ${returnJourney.TransferTime}`,
          ),
        );
    }
  };

  const handlePickupTime = (time, timeString) => {
    setPickUpTime(time);
    setDepature({ ...depature, TransferTime: timeString });
  };

  const handlePickupdate = (e) => {
    if (e !== null) {
      setPickUpDate(e.getTime() - e.getTimezoneOffset() * 60000);
      setDepature({
        ...depature,
        TransferDate: new Date(e.getTime() - e.getTimezoneOffset() * 60000)
          .toISOString()
          .split(".")[0],
      });
      delete formErrors["transferDate"];
      let d = moment(e);
      let tm = moment(e).add(1, "days")._d;
      setMinReturn(tm.getTime() - tm.getTimezoneOffset() * 60000);

      if (new Date(d) >= new Date(returnDate)) {
        setReturnDate(tm.getTime() - tm.getTimezoneOffset() * 60000);

        setReturnJourney({
          ...returnJourney,
          TransferDate: new Date(tm).toISOString().split(".")[0],
        });

        setReturnInput(
          `${moment(tm).format("YYYY-MM-DD")} ${returnInput.split(" ")[1]}`,
        );
      }
    }
  };

  const handleReturnDate = (e) => {
    setReturnDate(e.getTime() - e.getTimezoneOffset() * 60000);

    setReturnJourney({
      ...returnJourney,
      PickUp: depature.DropOff,
      DropOff: depature.PickUp,

      TransferDate: new Date(e.getTime() - e.getTimezoneOffset() * 60000)
        .toISOString()
        .split(".")[0],
    });
  };

  const handleReturnTime = (time, timeString) => {
    setReturnTime(time);
    setReturnJourney({
      PickUp: depature.DropOff,
      DropOff: depature.PickUp,
      ...returnJourney,
      TransferTime: timeString,
    });
  };

  const handleSwipeLocation = () => {
    if (locationType === 0) {
      setLocationType(1);
    } else {
      setLocationType(0);
    }
    let tempInput = dropInput;

    setPickUpInput(tempInput);
    setDropInput(pickUpInput);

    setDepature({
      ...depature,
      PickUp: depature.DropOff,
      DropOff: depature.PickUp,
    });

    setReturnJourney({
      ...returnJourney,
      DropOff: depature.PickUp,
      PickUp: depature.DropOff,
    });
  };

  const handleInputChange = (e, type) => {
    if (type === "pickup") {
      setDepature({ ...depature, PickUp: undefined });
    } else {
      setDepature({ ...depature, DropOff: undefined });
    }

    setCurrentInput(e.target.name);
    if (type === "pickup") {
      setPickUpInput(e.target.value);
    } else {
      setDropInput(e.target.value);
    }

    let data;
    if (e.target.name === "Hotel") {
      data = {
        type: "TransferAccomodationDetail",
        name: e.target.value,
      };
    } else {
      data = {
        type: "TransferAirportDetail",
        name: e.target.value,
      };
    }

    if (e.target.value.length > 2) {
      dispatch(fetchAirHotelData({ data, Authorization }));
    } else {
      setDropList([]);
      setPickUpList([]);
    }
  };

  const handleListInput = (val, type) => {
    if (type === "pickup") {
      setPickUpList([]);
      setPickUpInput(val.name);
      setPickupCity(val.cityName);
      let Pickup = {
        LocationType:
          pickUpType === "Hotel"
            ? "TransferAccomodationDetail"
            : "TransferAirportDetail",
        cityId: val.cityId,
        cityName: val.cityName,
        countryCode: val.countryCode,
        locationName: val.name,
        code: val.code,
      };
      setDepature({ ...depature, PickUp: Pickup });
      setReturnJourney({ ...returnJourney, DropOff: Pickup });
    } else {
      setDropList([]);
      setDropInput(val.name);
      setDropoffCity(val.cityName);
      let drop = {
        LocationType:
          dropType === "Hotel"
            ? "TransferAccomodationDetail"
            : "TransferAirportDetail",
        cityId: val.cityId,
        cityName: val.cityName,
        countryCode: val.countryCode,
        locationName: val.name,
        code: val.code,
      };
      setDepature({ ...depature, DropOff: drop });
      setReturnJourney({ ...returnJourney, PickUp: drop });
    }
  };

  const validate = () => {
    let errors = {};
    if (pickupRef.current.value === "") {
      errors.pickup = "Enter Name of Pickup Location!";
    } else if (
      pickupRef.current.value !== "" &&
      depature.PickUp === undefined
    ) {
      errors.pickup = "Select a Valid Pickup Location!";
    }

    if (dropRef.current.value === "") {
      errors.drop = "Enter Name of Drop off Location";
    } else if (dropRef.current.value !== "" && depature.DropOff === undefined) {
      errors.drop = "Select a Valid Drop Location!";
    }

    if (depature.TransferDate === undefined) {
      errors.transferDate = "Please Select Date of Transfer!";
    }

    if (pickupTime === "") {
      errors.pickupTime = "Please Select Pickup Time!";
    }

    if (tripType === "roundtrip") {
      if (returnDate === "" || returnTime === "") {
        errors.return = "Please Select Return Date And Time!";
      }
    }

    return errors;
  };

  const checkErrors = (name) => {
    let check = validate();

    if (name in check) {
      setFormErrors({ ...formErrors, [name]: check[name] });
    } else {
      setFormErrors({ ...formErrors, [name]: "" });
    }
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    setFormErrors(validate());
    setIsSubmit(true);
  };

  const hoverEnterHandler = (type) => {
    if (type === "pickup" && pickUpInput !== "") {
      setPickupHover(true);
    }
    if (type === "dropoff" && dropInput !== "") {
      setDropoffHover(true);
    }
  };

  const hoverLeaveHandler = (type) => {
    if (type === "pickup") {
      setPickupHover(false);
    } else {
      setDropoffHover(false);
    }
  };

  return (
    <>
      <div className="bf-wrap">
        <div className="bf-toolbar">
          <div className="bf-radio-group">
            <label>
              <input
                type="radio"
                value="oneway"
                checked={tripType === "oneway"}
                onChange={handleCheckBox}
              />
              <span>One Way</span>
            </label>
            <label>
              <input
                type="radio"
                value="roundtrip"
                checked={tripType === "roundtrip"}
                onChange={handleCheckBox}
              />
              <span>Round Trip</span>
            </label>
          </div>
        </div>

        <form
          className={
            tripType === "roundtrip" ? "bf-form bf-form--roundtrip" : "bf-form"
          }
        >
          <div className="bf-field">
            <span
              className="bf-swap-btn"
              onClick={handleSwipeLocation}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="15"
                viewBox="0 0 20 15"
                fill="none"
              >
                <g clipPath="url(#clip0_137_513t)">
                  <path
                    d="M0.355323 4.43457C0.533418 4.57705 0.747131 4.59486 0.978654 4.59486C6.26806 4.59486 11.5397 4.59486 16.8291 4.59486C16.9181 4.59486 17.0071 4.59486 17.1674 4.59486C16.651 5.11133 16.1879 5.55657 15.7427 6.01961C15.3509 6.41142 15.3331 6.91009 15.6714 7.26627C16.0276 7.62246 16.5263 7.58684 16.9181 7.19504C17.8442 6.26895 18.7703 5.34286 19.6964 4.41676C20.1238 3.98934 20.1238 3.52629 19.6964 3.09887C18.8949 2.27963 18.0757 1.47821 17.2743 0.676782C17.1496 0.552116 17.025 0.409641 16.8825 0.284975C16.5085 -0.0712142 16.0098 -0.0712142 15.6714 0.267165C15.3331 0.605544 15.3509 1.10421 15.7071 1.47821C16.1167 1.90563 16.5441 2.31525 16.9537 2.72487C17.0071 2.7783 17.0784 2.83172 17.1496 2.88515C17.1318 2.90296 17.1318 2.92077 17.114 2.93858C17.025 2.93858 16.9359 2.93858 16.8291 2.93858C11.5753 2.93858 6.32149 2.93858 1.0677 2.93858C0.978654 2.93858 0.889607 2.93858 0.800559 2.93858C0.444371 2.95639 0.14161 3.20572 0.052563 3.56191C-0.0542937 3.86467 0.0703724 4.22086 0.355323 4.43457Z"
                    fill="currentColor"
                  ></path>
                  <path
                    d="M19.4119 9.6171C19.2694 9.56367 19.1447 9.58148 19.0022 9.58148C13.7306 9.58148 8.45905 9.58148 3.18746 9.58148C3.09841 9.58148 3.00936 9.58148 2.84908 9.58148C3.36555 9.065 3.8286 8.60196 4.29164 8.13891C4.66564 7.76491 4.70126 7.26625 4.36288 6.91006C4.0245 6.55387 3.50803 6.57168 3.11622 6.96349C2.17232 7.90739 1.24623 8.83348 0.30233 9.75957C-0.107287 10.1692 -0.107287 10.6322 0.30233 11.0597C1.24623 11.9858 2.17232 12.9118 3.09841 13.8379C3.49022 14.2297 3.98888 14.2654 4.34507 13.9092C4.70126 13.553 4.66564 13.0543 4.27383 12.6625C3.81079 12.1995 3.34774 11.7364 2.83127 11.2378C2.99156 11.2378 3.0806 11.2378 3.16965 11.2378C8.42343 11.2378 13.6772 11.2378 18.9488 11.2378C19.0379 11.2378 19.1269 11.2378 19.216 11.2378C19.6256 11.2021 19.9461 10.8816 19.9996 10.4898C20.0352 10.098 19.7859 9.74176 19.4119 9.6171Z"
                    fill="currentColor"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_137_513t">
                    <rect width="20" height="14.1585" fill="white"></rect>
                  </clipPath>
                </defs>
              </svg>
            </span>
            <div className="bf-icon">
              {locationType === 0 ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="134"
                  height="100"
                  viewBox="0 0 134 100"
                  fill="none"
                >
                  <path
                    d="M132.805 46.7638C131.763 40.8613 128.152 37.4371 122.36 36.3284C104.919 33.0347 87.4452 29.7736 69.9717 26.5125C56.3379 23.9689 42.6715 21.4252 29.0376 18.9142C28.0289 18.7185 27.5083 18.262 27.0527 17.3489C24.5147 12.229 21.9441 7.10909 19.341 2.02181C18.3648 0.0977695 17.2259 -0.391392 15.2085 0.293434C12.7355 1.1087 10.2951 1.92397 7.82215 2.77185C5.99996 3.42407 5.41426 4.40239 5.60949 6.35904C6.48805 15.1966 7.3666 24.0667 8.27769 32.9042C8.47293 34.9913 9.05863 35.6435 11.1411 36.1979C23.9615 39.5894 36.8144 42.981 49.6348 46.3399C52.3681 47.0573 55.1014 47.8074 58.095 48.59C57.5418 49.0466 57.2164 49.3074 56.891 49.6009C49.4721 56.3188 42.0207 63.004 34.6018 69.7218C33.6256 70.6023 32.9748 71.548 33.3653 72.9177C33.7558 74.2547 34.7319 74.8091 36.066 75.0048C41.012 75.82 45.9579 76.6679 50.9038 77.5484C52.3681 77.8093 53.572 77.5484 54.8411 76.7983C66.848 69.9175 78.8874 63.0692 90.9269 56.2209C91.48 55.8948 92.326 55.7644 92.9768 55.8948C101.307 57.4601 109.604 59.1233 117.934 60.6886C123.336 61.6996 127.696 59.906 130.755 55.3404C131.796 53.8077 132.251 51.9163 133 50.1553C133 49.1118 133 48.0682 133 47.0247C132.935 46.9921 132.837 46.8616 132.805 46.7638ZM119.041 55.3078C110.255 53.6121 101.47 51.9163 92.684 50.1553C91.3824 49.8944 90.3412 50.1553 89.2348 50.8075C77.1629 57.6884 65.1234 64.5693 53.0189 71.4176C52.3681 71.7763 51.4895 71.9393 50.7411 71.8415C47.9753 71.4828 45.2095 70.961 42.1183 70.4392C45.9579 66.9825 49.5697 63.7214 53.149 60.493C57.1188 56.9384 61.056 53.3512 65.0258 49.7966C65.9694 48.9487 66.7178 48.003 66.3924 46.6334C66.067 45.2311 64.9607 44.6767 63.6917 44.3506C47.4872 40.0134 31.2503 35.7414 15.0458 31.502C13.9395 31.2085 13.549 30.7519 13.4514 29.6105C12.8332 22.7949 12.1498 15.9792 11.4014 9.16357C11.2713 7.89175 11.4665 7.10909 12.8657 6.91342C13.6141 6.78298 14.33 6.45687 15.176 6.16338C15.4037 6.58732 15.6315 7.01126 15.8268 7.4352C18.2346 12.1964 20.6425 16.9249 23.0179 21.7187C23.6687 23.0558 24.6123 23.7406 26.0765 24.0015C57.7045 29.8714 89.3325 35.8066 120.928 41.7091C124.54 42.394 126.72 44.2854 127.273 47.1551C128.217 52.112 124.019 56.2862 119.041 55.3078Z"
                    fill="currentColor"
                  />
                  <path
                    d="M129.887 94.4734C129.105 94.4082 128.322 94.4082 127.494 94.4082C107.245 94.4082 86.9504 94.4082 66.7016 94.4082C46.3607 94.4082 26.0659 94.4082 5.72502 94.4082C4.94268 94.4082 4.11431 94.4082 3.33197 94.4734C1.72127 94.6039 0.66281 95.2887 0.202609 96.3649C-0.671772 98.3867 1.35311 99.9194 4.94268 99.9194C46.0386 99.9194 87.0885 99.9194 128.184 99.9194C128.967 99.9194 129.795 99.8868 130.531 99.7238C132.28 99.3324 133.293 98.1911 133.109 96.9192C132.97 95.6474 131.728 94.6691 129.887 94.4734Z"
                    fill="currentColor"
                  />
                </svg>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="26"
                  height="32"
                  viewBox="0 0 26 32"
                  fill="none"
                >
                  <path
                    d="M12.8 16C11.04 16 9.6 14.56 9.6 12.8C9.6 11.04 11.04 9.6 12.8 9.6C14.56 9.6 16 11.04 16 12.8C16 14.56 14.56 16 12.8 16ZM22.4 13.12C22.4 7.312 18.16 3.2 12.8 3.2C7.44 3.2 3.2 7.312 3.2 13.12C3.2 16.864 6.32 21.824 12.8 27.744C19.28 21.824 22.4 16.864 22.4 13.12ZM12.8 0C19.52 0 25.6 5.152 25.6 13.12C25.6 18.432 21.328 24.72 12.8 32C4.272 24.72 0 18.432 0 13.12C0 5.152 6.08 0 12.8 0Z"
                    fill="currentColor"
                  />
                </svg>
              )}
            </div>
            <div className="bf-control">
              <label className="bf-label" htmlFor="">
                {locationType === 0 ? "From Airport" : "From Hotel"}
              </label>
              {pickUpInput !== "" && pickupCity !== "" && (
                <h5 className="bf-subvalue">{pickupCity}</h5>
              )}
              <input
                type="text"
                className="bf-input"
                placeholder={
                  locationType === 0 ? "Enter Airport" : "Enter Hotel"
                }
                autoComplete="off"
                onMouseEnter={() => hoverEnterHandler("pickup")}
                onMouseLeave={() => hoverLeaveHandler("pickup")}
                name={pickUpType}
                value={pickUpInput}
                onChange={(e) => handleInputChange(e, "pickup")}
                onBlur={(e) => {
                  setPickUpList([]);
                  checkErrors("pickup");
                }}
                ref={pickupRef}
              />

              {pickupHover && <p className="bf-hover-tag">{pickUpInput}</p>}
              <span className="bf-error">{formErrors?.pickup}</span>

              <ul
                className={`bf-suggestions ${
                  pickUpList.length > 0 ? "is-open" : ""
                }`}
              >
                {pickUpList.length > 0 &&
                  pickUpList.map((val, i) => (
                    <li
                      onMouseDown={() => handleListInput(val, "pickup")}
                      key={i}
                    >
                      <span className="bf-suggest-main">{val.name}</span>
                      <span className="bf-suggest-sub">{val.cityName}</span>
                    </li>
                  ))}
              </ul>
            </div>
          </div>

          <div className="bf-field">
            <div className="bf-icon">
              {locationType === 0 ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="26"
                  height="32"
                  viewBox="0 0 26 32"
                  fill="none"
                >
                  <path
                    d="M12.8 16C11.04 16 9.6 14.56 9.6 12.8C9.6 11.04 11.04 9.6 12.8 9.6C14.56 9.6 16 11.04 16 12.8C16 14.56 14.56 16 12.8 16ZM22.4 13.12C22.4 7.312 18.16 3.2 12.8 3.2C7.44 3.2 3.2 7.312 3.2 13.12C3.2 16.864 6.32 21.824 12.8 27.744C19.28 21.824 22.4 16.864 22.4 13.12ZM12.8 0C19.52 0 25.6 5.152 25.6 13.12C25.6 18.432 21.328 24.72 12.8 32C4.272 24.72 0 18.432 0 13.12C0 5.152 6.08 0 12.8 0Z"
                    fill="currentColor"
                  />
                </svg>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="26"
                  height="18"
                  viewBox="0 0 5184 3558"
                  fill="none"
                >
                  <path
                    d="M4799.65 7.42785C4613.91 -22.2841 4443.02 14.8558 4272.13 96.5635C3833.78 304.547 3402.85 505.102 2964.49 705.657C2927.34 720.513 2897.62 720.513 2860.47 713.085C2392.4 527.386 1916.89 341.687 1448.81 163.415C1374.51 133.703 1292.79 111.419 1211.06 103.992C1025.31 89.1356 869.287 222.839 854.427 408.538C846.997 475.39 869.287 512.53 921.295 549.67C1211.06 750.225 1500.82 950.781 1790.58 1143.91C1820.3 1166.19 1850.02 1188.48 1887.17 1210.76C1879.74 1218.19 1872.31 1218.19 1864.88 1225.62C1693.99 1307.32 1515.68 1389.03 1344.79 1470.74C1322.5 1485.59 1300.22 1478.17 1270.5 1478.17C973.304 1403.89 676.112 1329.61 371.49 1255.33C304.622 1240.47 267.473 1247.9 237.754 1307.32C156.026 1455.88 74.2981 1604.44 -7.42969 1745.57C-7.42969 1760.43 -7.42969 1782.71 -7.42969 1797.57C14.8597 1834.71 52.0087 1856.99 96.5875 1871.85C215.464 1916.42 334.341 1968.41 453.218 2020.41C549.805 2064.98 653.822 2102.12 757.84 2146.68C705.831 2168.97 668.682 2191.25 631.533 2206.11C564.665 2243.25 542.375 2280.39 579.524 2354.67C638.963 2488.37 698.401 2614.65 757.84 2740.92C794.989 2830.06 839.567 2844.91 928.725 2800.35C1411.66 2570.08 1902.03 2347.24 2384.97 2116.97C2444.4 2087.26 2459.26 2057.55 2466.69 1998.13C2474.12 1864.42 2488.98 1730.72 2503.84 1597.01C2503.84 1559.87 2526.13 1537.59 2563.28 1537.59C2600.43 1537.59 2622.72 1552.45 2630.15 1582.16C2637.58 1597.01 2630.15 1619.3 2630.15 1634.15C2607.86 1894.13 2578.14 2161.54 2555.85 2421.52C2526.13 2763.21 2488.98 3112.32 2459.26 3454.01C2451.83 3535.72 2488.98 3565.43 2570.71 3558C2600.43 3558 2630.15 3543.14 2652.44 3520.86C2719.31 3461.44 2749.03 3379.73 2778.75 3298.02C2949.63 2785.49 3127.95 2272.96 3298.83 1760.43C3373.13 1552.45 3440 1337.04 3514.3 1129.05C3536.58 1069.63 3566.3 1047.34 3610.88 1062.2C3655.46 1077.06 3662.89 1114.2 3648.03 1173.62C3633.17 1225.62 3610.88 1277.61 3596.02 1329.61C3566.3 1411.32 3536.58 1500.45 3506.87 1597.01C3937.79 1396.46 4361.29 1195.9 4777.36 995.348C4918.53 928.497 5029.97 824.505 5104.27 690.802C5290.02 386.255 5133.99 59.4237 4799.65 7.42785Z"
                    fill="currentColor"
                  />
                </svg>
              )}
            </div>

            <div className="bf-control">
              <label className="bf-label" htmlFor="">
                {locationType === 1 ? "To Airport" : "To Hotel"}
              </label>
              {dropInput !== "" && dropoffCity !== "" && (
                <h5 className="bf-subvalue">{dropoffCity}</h5>
              )}
              <input
                type="text"
                className="bf-input"
                placeholder={
                  locationType === 1 ? "Enter Airport" : "Enter Hotel"
                }
                name={dropType}
                onMouseEnter={() => hoverEnterHandler("dropoff")}
                onMouseLeave={() => hoverLeaveHandler("dropoff")}
                value={dropInput}
                autoComplete="off"
                onChange={(e) => handleInputChange(e, "drop")}
                onBlur={() => {
                  setDropList([]);
                  checkErrors("drop");
                }}
                ref={dropRef}
              />
              {dropoffHover && <p className="bf-hover-tag">{dropInput}</p>}
              <span className="bf-error">{formErrors?.drop}</span>

              <ul
                className={`bf-suggestions ${
                  dropList.length > 0 ? "is-open" : ""
                }`}
              >
                {dropList.length > 0 &&
                  dropList.map((val, i) => (
                    <li onMouseDown={() => handleListInput(val, "drop")} key={i}>
                      <span className="bf-suggest-main">{val.name}</span>
                      <span className="bf-suggest-sub">
                        {val.address1}, {val.cityName}
                      </span>
                    </li>
                  ))}
              </ul>
            </div>
          </div>

          <div className="bf-field">
            <div className="bf-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="29"
                height="32"
                viewBox="0 0 29 32"
                fill="none"
              >
                <path
                  d="M6.4 14.4H9.6V17.6H6.4V14.4ZM28.8 6.4V28.8C28.8 30.56 27.36 32 25.6 32H3.2C1.424 32 0 30.56 0 28.8L0.016 6.4C0.016 4.64 1.424 3.2 3.2 3.2H4.8V0H8V3.2H20.8V0H24V3.2H25.6C27.36 3.2 28.8 4.64 28.8 6.4ZM3.2 9.6H25.6V6.4H3.2V9.6ZM25.6 28.8V12.8H3.2V28.8H25.6ZM19.2 17.6H22.4V14.4H19.2V17.6ZM12.8 17.6H16V14.4H12.8V17.6Z"
                  fill="currentColor"
                ></path>
              </svg>
            </div>
            <div className="bf-control">
              <label className="bf-label" htmlFor="">Pickup Date</label>
              <DatePicker
                placeholderText="Date"
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                dateFormat="yyyy-MM-dd"
                name="pickupdate"
                autoComplete="off"
                minDate={startPickup}
                maxDate={endDateAll}
                selected={Date.parse(depature?.TransferDate)}
                value={
                  depature?.TransferDate !== "" &&
                  depature?.TransferDate !== undefined
                    ? slashFormatter(Date.parse(depature?.TransferDate))
                    : ""
                }
                onBlur={() => checkErrors("transferDate")}
                className="bf-input"
                onChange={handlePickupdate}
              />
              <span className="bf-error">{formErrors?.transferDate}</span>
            </div>
          </div>

          <div className="bf-field">
            <div className="bf-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
              >
                <path
                  d="M21.0952 23.4266L23.4266 21.1704L17.6357 15.342V8.15981H14.5523V16.6204L21.0952 23.4266ZM15.9812 32C13.7752 32 11.7007 31.5801 9.75793 30.7403C7.81512 29.9005 6.12299 28.7599 4.68155 27.3185C3.24011 25.877 2.09949 24.1849 1.25969 22.2421C0.419898 20.2993 0 18.2248 0 16.0188C0 13.8128 0.419898 11.7383 1.25969 9.79554C2.09949 7.85272 3.24011 6.1606 4.68155 4.71915C6.12299 3.27771 7.81512 2.13083 9.75793 1.2785C11.7007 0.426165 13.7752 0 15.9812 0C18.1872 0 20.2617 0.426165 22.2045 1.2785C24.1473 2.13083 25.8394 3.27771 27.2808 4.71915C28.7223 6.1606 29.8692 7.85272 30.7215 9.79554C31.5738 11.7383 32 13.8128 32 16.0188C32 18.2248 31.5738 20.2993 30.7215 22.2421C29.8692 24.1849 28.7223 25.877 27.2808 27.3185C25.8394 28.7599 24.1473 29.9005 22.2045 30.7403C20.2617 31.5801 18.1872 32 15.9812 32ZM15.9436 28.4653C19.378 28.4653 22.3173 27.2558 24.7615 24.8367C27.2056 22.4175 28.4277 19.4783 28.4277 16.0188C28.4277 12.5844 27.2056 9.65139 24.7615 7.21974C22.3173 4.78809 19.3905 3.57227 15.9812 3.57227C12.5468 3.57227 9.61379 4.78809 7.18214 7.21974C4.75049 9.65139 3.53467 12.5844 3.53467 16.0188C3.53467 19.4783 4.75049 22.4175 7.18214 24.8367C9.61379 27.2558 12.5343 28.4653 15.9436 28.4653Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <div className="bf-control">
              <label className="bf-label" htmlFor="">Pickup Time</label>
              <TimePicker
                bordered={false}
                format={"HH:mm"}
                use12Hours
                onChange={handlePickupTime}
                onBlur={() => checkErrors("pickupTime")}
                value={pickupTime}
              />
              <span className="bf-error">{formErrors?.pickupTime}</span>
            </div>
          </div>

          {tripType === "roundtrip" && (
            <div className="bf-field">
              <div className="bf-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="28"
                  viewBox="0 0 32 28"
                  fill="none"
                >
                  <path
                    d="M4.77328 7.53029C6.17648 8.69988 7.51421 9.82269 8.86128 10.9174C9.07644 11.0952 9.13257 11.1888 8.91741 11.4227C8.53387 11.8344 8.18775 12.2742 7.84162 12.7139C7.72936 12.8543 7.66388 12.8636 7.51421 12.742C5.05392 10.6835 2.58428 8.62503 0.114639 6.56655C-0.0631006 6.41684 -0.0163271 6.35134 0.133348 6.22971C2.59363 4.18994 5.05392 2.14082 7.50485 0.0916959C7.66388 -0.0392982 7.72936 -0.0299415 7.85098 0.119766C8.21581 0.578246 8.58064 1.02737 8.97354 1.46713C9.13257 1.64491 9.06709 1.71977 8.91741 1.8414C7.64517 2.89871 6.37293 3.96538 5.10069 5.02269C5.0165 5.09754 4.93231 5.16304 4.79199 5.28468C4.99779 5.28468 5.1194 5.28468 5.24101 5.28468C10.4048 5.28468 15.5686 5.22854 20.7418 5.30339C25.2975 5.35953 28.7026 7.4648 30.7887 11.5163C34.1096 17.963 30.2835 25.9256 23.1927 27.4695C22.3788 27.6473 21.5556 27.7408 20.723 27.7408C14.4835 27.7408 8.24387 27.7408 2.00429 27.7502C1.74236 27.7502 1.66752 27.694 1.67687 27.4227C1.69558 26.8894 1.69558 26.3467 1.67687 25.8133C1.66752 25.5513 1.74236 25.4952 2.00429 25.4952C6.82196 25.5046 11.6303 25.5046 16.4479 25.5046C17.8512 25.5046 19.2544 25.5046 20.6576 25.5046C25.0543 25.4952 28.6371 22.5946 29.5632 18.2999C30.611 13.4344 27.2058 8.46596 22.2853 7.68C21.7801 7.59579 21.2656 7.54901 20.7511 7.54901C15.5312 7.54901 10.3019 7.54901 5.08198 7.54901C5.00715 7.53029 4.94166 7.53029 4.77328 7.53029Z"
                    fill="currentColor"
                  />
                </svg>
              </div>
              <div className="bf-control">
                <label className="bf-label" htmlFor="">Add Return</label>
                <input
                  type="text"
                  className="bf-input"
                  onClick={() => handleReturnTransfer("open")}
                  placeholder="Time and Date"
                  value={returnInput}
                  readOnly
                  autoComplete="off"
                />

                <div className={`bf-return-popup ${returnPopup ? "show" : ""}`}>
                  <div className="bf-return-row">
                    <img src="assets/images/calendar.svg" />
                    <DatePicker
                      placeholderText="Return Date"
                      peekNextMonth
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      dateFormat="yyyy-MM-dd"
                      name="returnDate"
                      autoComplete="off"
                      minDate={minReturn}
                      maxDate={endDateAll}
                      selected={Date.parse(returnJourney?.TransferDate)}
                      value={
                        returnJourney?.TransferDate !== "" &&
                        returnJourney?.TransferDate !== undefined
                          ? slashFormatter(
                              Date.parse(returnJourney?.TransferDate),
                            )
                          : ""
                      }
                      className="bf-input"
                      onChange={handleReturnDate}
                    />
                  </div>
                  <div className="bf-return-row">
                    <img src="assets/images/clock.svg" />
                    <TimePicker
                      bordered={false}
                      format={"HH:mm"}
                      use12Hours
                      onChange={handleReturnTime}
                      value={returnTime}
                    />
                  </div>
                  <a
                    className="bf-btn-apply"
                    onClick={() => handleReturnTransfer("close")}
                  >
                    Confirm
                  </a>
                </div>
                <span className="bf-error">{formErrors?.return}</span>
              </div>
            </div>
          )}

          <div className="bf-field">
            <div className="bf-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="24"
                viewBox="0 0 32 24"
                fill="none"
              >
                <path
                  d="M22.793 13.2798C24.7857 14.6326 26.1821 16.4653 26.1821 18.9089V23.2726H32.0002V18.9089C32.0002 15.738 26.8075 13.8617 22.793 13.2798Z"
                  fill="currentColor"
                ></path>
                <path
                  d="M20.3633 11.6364C23.5778 11.6364 26.1814 9.03273 26.1814 5.81818C26.1814 2.60364 23.5778 0 20.3633 0C19.6796 0 19.0396 0.145454 18.4287 0.349091C19.636 1.84727 20.3633 3.75273 20.3633 5.81818C20.3633 7.88364 19.636 9.78909 18.4287 11.2873C19.0396 11.4909 19.6796 11.6364 20.3633 11.6364Z"
                  fill="currentColor"
                ></path>
                <path
                  d="M11.6365 11.6364C14.8511 11.6364 17.4547 9.03273 17.4547 5.81818C17.4547 2.60364 14.8511 0 11.6365 0C8.422 0 5.81836 2.60364 5.81836 5.81818C5.81836 9.03273 8.422 11.6364 11.6365 11.6364ZM11.6365 2.90909C13.2365 2.90909 14.5456 4.21818 14.5456 5.81818C14.5456 7.41818 13.2365 8.72727 11.6365 8.72727C10.0365 8.72727 8.72745 7.41818 8.72745 5.81818C8.72745 4.21818 10.0365 2.90909 11.6365 2.90909Z"
                  fill="currentColor"
                ></path>
                <path
                  d="M11.6364 13.0909C7.75273 13.0909 0 15.04 0 18.9091V23.2727H23.2727V18.9091C23.2727 15.04 15.52 13.0909 11.6364 13.0909ZM20.3636 20.3636H2.90909V18.9236C3.2 17.8763 7.70909 16 11.6364 16C15.5636 16 20.0727 17.8763 20.3636 18.9091V20.3636Z"
                  fill="currentColor"
                ></path>
              </svg>
            </div>
            <div className="bf-control">
              <label className="bf-label" htmlFor="">Travellers</label>
              <div className="bf-counter">
                <button
                  onClick={() => travellersCount > 1 && dispatch(decCount())}
                  type="button"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      d="M4 8.54H12V7.34H4V8.54ZM8 16C6.90667 16 5.87333 15.79 4.9 15.37C3.92667 14.95 3.07667 14.3767 2.35 13.65C1.62333 12.9233 1.05 12.0733 0.63 11.1C0.21 10.1267 0 9.09333 0 8C0 6.89333 0.21 5.85333 0.63 4.88C1.05 3.90667 1.62333 3.06 2.35 2.34C3.07667 1.62 3.92667 1.05 4.9 0.63C5.87333 0.21 6.90667 0 8 0C9.10667 0 10.1467 0.21 11.12 0.63C12.0933 1.05 12.94 1.62 13.66 2.34C14.38 3.06 14.95 3.90667 15.37 4.88C15.79 5.85333 16 6.89333 16 8C16 9.09333 15.79 10.1267 15.37 11.1C14.95 12.0733 14.38 12.9233 13.66 13.65C12.94 14.3767 12.0933 14.95 11.12 15.37C10.1467 15.79 9.10667 16 8 16Z"
                      fill="currentColor"
                    />
                  </svg>
                </button>
                <input
                  type="text"
                  value={travellersCount}
                  onChange={() => {
                    return;
                  }}
                />
                <button
                  type="button"
                  onClick={() => travellersCount < 8 && dispatch(incCount())}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      d="M7.46 12H8.66V8.68H12V7.48H8.66V4H7.46V7.48H4V8.68H7.46V12ZM8 16C6.90667 16 5.87333 15.79 4.9 15.37C3.92667 14.95 3.07667 14.3767 2.35 13.65C1.62333 12.9233 1.05 12.0733 0.63 11.1C0.21 10.1267 0 9.08667 0 7.98C0 6.88667 0.21 5.85333 0.63 4.88C1.05 3.90667 1.62333 3.06 2.35 2.34C3.07667 1.62 3.92667 1.05 4.9 0.63C5.87333 0.21 6.91333 0 8.02 0C9.11333 0 10.1467 0.21 11.12 0.63C12.0933 1.05 12.94 1.62 13.66 2.34C14.38 3.06 14.95 3.90667 15.37 4.88C15.79 5.85333 16 6.89333 16 8C16 9.09333 15.79 10.1267 15.37 11.1C14.95 12.0733 14.38 12.9233 13.66 13.65C12.94 14.3767 12.0933 14.95 11.12 15.37C10.1467 15.79 9.10667 16 8 16Z"
                      fill="currentColor"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>

          <div className="bf-submit">
            <SearchButton func={handleFormSubmit} />
          </div>
        </form>
      </div>
    </>
  );
};

export default TransferForm;